var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',{staticClass:"styled-h1"},[_vm._v("Workshops")]),_c('v-card',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/workshop-forms/list"}},[_vm._v("Gegeven workshops")]),_c('v-tab',{attrs:{"to":"/workshop-forms/stats"}},[_vm._v("Statistiek")])],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }